import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./ui/command";

export const BarangCombobox = ({ gudang, value, onChange, testId = "barang-combobox" }) => {
  const [open, setOpen] = useState(false);
  const selected = gudang.find((b) => b.id === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button data-testid={testId} type="button" variant="outline" role="combobox" aria-expanded={open}
          className="w-full justify-between font-normal border-zinc-300 bg-white hover:bg-zinc-50">
          <span className="truncate">
            {selected ? `${selected.Kode_Barang} — ${selected.Nama_Barang} (stok ${selected.Stok_Tersedia})` : "Cari & pilih sparepart..."}
          </span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-white" align="start">
        <Command filter={(val, search) => (val.toLowerCase().includes(search.toLowerCase()) ? 1 : 0)}>
          <CommandInput data-testid={`${testId}-search`} placeholder="Ketik kode/nama barang..." />
          <CommandList>
            <CommandEmpty>Barang tidak ditemukan.</CommandEmpty>
            <CommandGroup>
              {gudang.map((b) => (
                <CommandItem key={b.id} value={`${b.Kode_Barang} ${b.Nama_Barang} ${b.Kategori_Barang}`}
                  disabled={b.Stok_Tersedia <= 0}
                  data-testid={`${testId}-item-${b.Kode_Barang}`}
                  onSelect={() => { onChange(b.id); setOpen(false); }}>
                  <Check className={`mr-2 h-4 w-4 ${value === b.id ? "opacity-100" : "opacity-0"}`} />
                  <span className="flex-1 truncate">{b.Kode_Barang} — {b.Nama_Barang}</span>
                  <span className={`ml-2 text-xs shrink-0 ${b.Stok_Tersedia <= b.Batas_Minimum_Stok ? "text-red-600 font-medium" : "text-zinc-500"}`}>
                    stok {b.Stok_Tersedia}
                  </span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
